export default class MinusTime {
    static fromData(data) {
        if (!data) {
            return;
        }

        let minusTime = new MinusTime();
        minusTime.day = data.day;
        minusTime.formattedDay = data.formatted_day;
        minusTime.weekday = data.weekday;
        minusTime.timeRange = data.time_range;
        minusTime.duration = data.duration;
        minusTime.comments = data.comments;
        minusTime.hint = data.hint;

        return minusTime;
    }
}
